import api from '@/services/api';
import { resolveMediaUrl } from '@/helpers/mediaUrl';
import { DEFAULT_SITE_LOGO } from '@/helpers/siteLogo';

export const state = {
  logoPath: null,
  logoVersion: 0,
  loaded: false,
};

export const getters = {
  siteLogoUrl(st) {
    if (!st.logoPath) return DEFAULT_SITE_LOGO;
    const base = resolveMediaUrl(st.logoPath);
    if (!base) return DEFAULT_SITE_LOGO;
    return st.logoVersion ? `${base}?v=${st.logoVersion}` : base;
  },
  hasCustomLogo(st) {
    return Boolean(st.logoPath);
  },
};

export const mutations = {
  SET_BRANDING(st, { logoPath }) {
    st.logoPath = logoPath || null;
    st.logoVersion += 1;
    st.loaded = true;
  },
};

export const actions = {
  async fetchBranding({ commit }) {
    try {
      const { data } = await api.get('/api/v1/public/site-branding');
      commit('SET_BRANDING', { logoPath: data?.logo_url || null });
    } catch {
      commit('SET_BRANDING', { logoPath: null });
    }
  },
  applyBranding({ commit }, logoPath) {
    commit('SET_BRANDING', { logoPath: logoPath || null });
  },
};
